var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header": "Detil PPFTZ"
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-catatan",
      modifiers: {
        "modal-catatan": true
      }
    }],
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.getCatatan(_vm.$store.state.barpin.header.id_aju)
      }
    }
  }, [_vm._v("\n      Catatan "), _c('i', {
    staticClass: "fa fa-bars"
  })])], 1), _vm._v(" "), _c('h3', [_vm._v("Header")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, _vm._l((this.$store.state.barpin.header), function(value, key) {
    return _c('tr', [_vm._l((_vm.headers), function(header) {
      return [(key === header.value) ? [_c('td', {
        staticClass: "bold",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(header.text))]), _vm._v(" "), _c('td', [_vm._v("\n                :\n                "), (key === 'jns_aju') ? [_vm._v("\n                  " + _vm._s(value === '1' ? 'Barang Pindahan' : (value === '2' ? 'Kendaraan Bermotor' : '')) + "\n                ")] : [_vm._v(_vm._s(value))]], 2)] : _vm._e()]
    })], 2)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, _vm._l((this.$store.state.barpin.header), function(value, key) {
    return _c('tr', [_vm._l((_vm.headers2), function(header) {
      return [(key === header.value) ? [_c('td', {
        staticClass: "bold",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(header.text))]), _vm._v(" "), _c('td', [_vm._v(": "), (key === 'pel_muat') ? [_vm._v("\n                  " + _vm._s(value + ' - ' + _vm.$store.state.barpin.header.ref_pel_muat.NM_LOKASI) + "\n                ")] : _vm._e(), _vm._v(" "), (key === 'pel_tujuan') ? [_vm._v("\n                  " + _vm._s(value + ' - ' + _vm.$store.state.barpin.header.ref_pel_tujuan.NM_LOKASI) + "\n                ")] : [_vm._v(_vm._s(value))]], 2)] : _vm._e()]
    })], 2)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, _vm._l((this.$store.state.barpin.header), function(value, key) {
    return _c('tr', [_vm._l((_vm.headers3), function(header) {
      return [(key === header.value) ? [_c('td', {
        staticClass: "bold",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(header.text))]), _vm._v(" "), _c('td', [_vm._v(": " + _vm._s(value))])] : _vm._e()]
    })], 2)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, _vm._l((this.$store.state.barpin.header), function(value, key) {
    return _c('tr', [_vm._l((_vm.headers4), function(header) {
      return [(key === header.value) ? [_c('td', {
        staticClass: "bold",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(header.text))]), _vm._v(" "), _c('td', [_vm._v(": " + _vm._s(value))])] : _vm._e()]
    })], 2)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', [_c('h3', [_vm._v("File Upload")]), _vm._v(" "), _c('ListFilePpftz')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [(_vm.$store.state.barpin.kontainer.length) ? _c('div', [_c('h3', [_vm._v("Kontainer")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nomor Kontainer")]), _vm._v(" "), _c('th', [_vm._v("Ukuran/Jenis Kontainer")])])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.kontainer), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.NO_KONTAINER))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((item.UKURAN_KONTAINER) + " / " + (item.JNS_KONTAINER))))])])
  }))])]) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.barang.length) ? _c('div', [_c('h3', [_vm._v("Barang")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-responsive mt-3"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nama Barang")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Jumlah Barang")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nilai Barang")]), _vm._v(" "), _c('th', [_vm._v("Nilai BM")]), _vm._v(" "), _c('th', [_vm._v("Nilai PPN")]), _vm._v(" "), _c('th', [_vm._v("Nilai Pph")])])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.barang), function(item, index) {
    return _c('tr', {
      key: item.URAIAN_BARANG
    }, [_c('td', [_vm._v(_vm._s(item.URAIAN_BARANG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((item.JML_SATUAN) + " " + (item.JNS_SATUAN) + " / " + (item.JML_KEMASAN) + " " + (item.JNS_KEMASAN) + " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.CIF.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.NILAI_BM == null ? '' : item.NILAI_BM.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.NILAI_PPN == null ? '' : item.NILAI_PPN.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.NILAI_PPH == null ? '' : item.NILAI_PPH.toLocaleString()))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/ppftz/browse"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Kembali\n      ")])], 1)], 1), _vm._v(" "), _c('modal-catatan')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f6fdc2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/browse/DetilPpftz.vue
// module id = 387
// module chunks = 0